import { Injectable } from '@angular/core';
import {
  LorenBaseEndpointsService
} from '../../../shared/services/loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
  providedIn: 'root'
})
export class LorenRoleEndpointsService extends LorenBaseEndpointsService {

  constructor() {
    super();
  }

  roles() {
    return `${this.getApiServerUrl()}/user-roles`;
  }

  userRoles(id: number) {
    return `${this.getApiServerUrl()}/users/${id}/user-roles`;
  }

  userRolesById(id: number) {
    return `${this.roles()}/${id}`;
  }

}
